import { IBiz } from './biz'
import { IQueryParams } from './common'

export interface IDeposit extends IBiz {
  /**
   * æä½ç¼å·
   */
  operationID: string
  /**
   * æä½æ¶é´
   */
  createdAt: string
  /**
   * æä½ç±»å
   */
  depositType: EDepositType
  /**
   * ç®æ éé¢
   */
  depositAmt: number
  /**
   * å·²æ¶åéé¢
   */
  currDepositAmt?: number
  /**
   * æ¥æ¶åç
   */
  singlePercent?: number
  /**
   * æ¸ç®å¸ç§
   */
  depositCurr: string
  /**
   * ä¿è¯éç¶æ
   */
  status: EDepositStatus
  /**
   * å¤æ³¨
   */
  remark?: string
  /**
   * æ¶åè®°å½
   */
  logs?: IDepositLog[]

  /**
   * é¨åºæ»éé¢
   */
  totalAmt?: number
}

export interface IDepositLog {
  /**
   * æ¸ç®æ¥æ
   */
  settDate: string,
  /**
   * å½æ¥æ¸ç®éé¢
   */
  settAmt: number
  /**
   * å®éæ¶åéé¢
   */
  depositAmt: number
  /**
   * å©ä½éé¢
   */
  remainAmt: number
}

export interface IDepositQuery extends IQueryParams, IBiz {
  createdAtFrom?: string
  createdAtTo?: string
  targetAmtFrom?: number
  targetAmtTo?: number
  currency?: string
  depositType?: EDepositType
  status?: EDepositStatus
}

export enum EDepositType {
  Collection = 0,
  Return,
}

export enum EDepositStatus {
  Processing = 0,
  Finish,
  Abort,
}

export interface IDepositCollection extends IBiz {
  intStoreCode?: string,
  depositAmt?: number,
  depositCurr?: string,
  singlePercent?: number,
  remark?: string,
  totalAmt?: number,
}
